import PayOnLineIcon from './PayOnLineIcon';

export default PayOnLineIcon;
